import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;

  > h2 {
    font-weight: bold;
  }
`;

export const RowInputs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  align-items: stretch;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const AreaButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  max-height: 40px;
  > button {
    height: 40px;
    padding: 4px 8px;
  }
`;

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 1rem;
`;
